// Package imports:
import React from 'react';
// Component import.
import Almennt from '../../components/Markhopalistar/ListarAlmennt';
import Entrypoint from '../Entrypoint';

const AlmenntPage: React.FC = ({
    ...props
}) => {
    return (
        <Entrypoint>
            <Almennt model={props as any} />
        </Entrypoint>
    );
}

export default AlmenntPage;